import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { AboutMeComponent } from './about-me/about-me.component';
import { AboutMyHomeComponent } from './about-my-home/about-my-home.component';
import { AboutMyDayComponent } from './about-my-day/about-my-day.component';
import { AboutMyLocationComponent } from './about-my-location/about-my-location.component';
import { ResultsComponent } from './results/results.component';

const routes: Routes = [
  { path: '', component: HomeComponent, data: {livePage: 'TracMyAir Main'} },
  { path: 'about-me', component: AboutMeComponent, data: {livePage: 'About Me'} },
  { path: 'about-my-home', component: AboutMyHomeComponent, data: {livePage: 'About My Home'} },
  { path: 'about-my-day', component: AboutMyDayComponent, data: {livePage: 'About My Day'} },
  { path: 'about-my-location', component: AboutMyLocationComponent, data: {livePage: 'About My Location'} },
  { path: 'exposure', component: ResultsComponent, data: {livePage: 'My Exposure Results'} },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
